import { EvaluatorReturnTypeToFilterType, FilterTarget, NestedTarget } from "./filters";

import { InputsFilterTargetLabelRenderer } from "@components/llama/Filters/DatapointFilter";

import { InputFilterTargetLabelRenderer } from "@components/llama/Filters/DatapointFilter";

import { BaseTarget } from "./filters";
import { Evaluator } from "@/types/app/evaluator";
import { JudgmentFilterTargetRenderer } from "@components/llama/Filters/EvaluationFilter";
import { EvaluatorFilterTargetRenderer } from "@components/llama/Filters/EvaluationFilter";

export const getDatapointSingleInputFilterTarget = (input: string): BaseTarget => {
  return {
    label: input,
    type: "text",
    entity: "inputs",
    target: input,
    errorState: false,
    render: (target: BaseTarget) => InputFilterTargetLabelRenderer(target),
  };
};

export const getDatapointInputsFilterTarget = (inputs: string[]): NestedTarget => {
  return {
    label: "Input",
    type: "nested",
    entity: "inputs",
    target: "input",
    errorState: false,
    childTargets: inputs.map((input) => getDatapointSingleInputFilterTarget(input)),
    render: (target: NestedTarget) => InputsFilterTargetLabelRenderer(target),
  };
};

export const getEvaluatorFilterTarget = (evaluator: Evaluator, evaluators: Evaluator[]): FilterTarget => {
  return {
    label: evaluator.name + " " + evaluator.version_id,
    type: EvaluatorReturnTypeToFilterType(evaluator.spec.return_type),
    entity: "evaluator" as const,
    options: evaluator.spec.options ?? [],
    target: evaluator,
    errorState: true,
    render: (target: NestedTarget) => EvaluatorFilterTargetRenderer(evaluators, target.target as Evaluator),
  };
};

export const getJudgmentFilterTarget = (evaluators: Evaluator[]): NestedTarget => {
  return {
    label: "Judgment",
    type: "nested",
    entity: "evaluator" as const,
    target: "Judgment",
    errorState: false,
    render: (target: NestedTarget) => JudgmentFilterTargetRenderer(target),
    childTargets: evaluators.map((e) => getEvaluatorFilterTarget(e, evaluators)),
  };
};
